import utils from '../utils';

export default {
    install(app) {
        // Add all utilities to globalProperties
        for (const [funcName, func] of Object.entries(utils)) {
            app.config.globalProperties[`$${funcName}`] = func;
        }
    }
};
